import { theme as defaultTheme } from "@mindlercare/ui-web";
import { styled } from "styled-components";

export const StyledNavbarWrapper = styled.nav`
  background-color: ${() => defaultTheme.COLORS.WHITE};
  display: flex;
  height: 64px;
  justify-content: flex-end;
  align-items: center;
  width: calc(100% - 216px);
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1000;
  gap: ${(props) => props.theme.SPACING.XL};
`;

export const StandoutBannerMessage = styled.div`
  color: red;
  font-size: 18px;
  text-align: center;
  margin: 0 auto;
  padding: 16px;
  background-color: rgba(255, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
`;

export const CloseButton = styled.button`
  all: unset;
  cursor: pointer;
  margin-left: 24px;
  display: flex;
`;
